import { IonBadge, IonItem, IonLabel, IonList } from '@ionic/react'
import { UserStatsProps } from '~types/components'

const UserStats: React.FC<UserStatsProps> = ({ stats }: UserStatsProps) => {
  const itemStyle = {
    '--padding-start': 0,
  }

  return (
    <div style={{ marginTop: 16, marginBottom: 32 }}>
      <div
        className="ion-no-padding"
        style={{ textTransform: 'uppercase', fontSize: 16 }}
      >
        Panoramica
      </div>
      <IonList>
        <IonItem lines="full" style={itemStyle}>
          <IonLabel>
            <h5>
              Libri messi a disposizione
            </h5>
          </IonLabel>
          <IonBadge color="primary" slot="end">
            { stats?.shelfs  }
          </IonBadge>
        </IonItem>
        <IonItem lines="full" style={itemStyle}>
          <IonLabel>
            <h5>
              Scambi totali
            </h5>
          </IonLabel>
          <IonBadge color="primary" slot="end">
            { stats?.borrows }
          </IonBadge>
        </IonItem>
        <IonItem lines="full" style={itemStyle}>
          <IonLabel>
            <h5>
              Libri prestati
            </h5>
          </IonLabel>
          <IonBadge color="primary" slot="end">
            { stats?.loaned }
          </IonBadge>
        </IonItem>
        <IonItem lines="full" style={itemStyle}>
          <IonLabel>
            <h5>
              Libri presi in prestito
            </h5>
          </IonLabel>
          <IonBadge color="primary" slot="end">
            { stats?.borrowed }
          </IonBadge>
        </IonItem>
      </IonList>
    </div>
  )
}

export default UserStats